
import React, { useEffect, useState } from 'react';
import { FaDonate,  FaCheckCircle } from 'react-icons/fa';
import { BsCurrencyDollar } from "react-icons/bs";
import axios from 'axios';
import { BASE_URL } from '../BaseURL';

export default function Dashboarddata() {
  const [summary, setSummary] = useState({
    totalDonations: 0,
    totalAmount: 0,
    successfulPayments: 0,
  });

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/donation/summary`);
        if (data.success) {
          setSummary(data.data);
        }
      } catch (err) {
        console.error('Failed to fetch summary:', err.message);
      }
    };

    fetchSummary();
  }, []);

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center">Dashboard </h2>
      <div className="row">
        {/* Total Donations */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-md border-1 p-3">
            <div className="d-flex align-items-center">
              <FaDonate size={40} className="text-success me-3" />
              <div>
                <h5 className="mb-1">Total Donations</h5>
                <h4>{summary.totalDonations}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* Total Amount */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm border-1 p-3">
            <div className="d-flex align-items-center">
              <BsCurrencyDollar size={40} className="text-success me-3" />
              <div>
                <h5 className="mb-1">Total Amount</h5>
                <h4>$ {summary.totalAmount.toLocaleString()}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* Successful Payments */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm border-1 p-3">
            <div className="d-flex align-items-center">
              <FaCheckCircle size={40} className="text-success me-3" />
              <div>
                <h5 className="mb-1">Successful Payments</h5>
                <h4>{summary.successfulPayments}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
